export const downloadStatus = Object.freeze({
  LOADING: 'LOADING',
  OK: 'OK',
  ERROR: 'ERROR',
});
